<template>
<main>
  <section class="box" v-loading="loading">
    <header>
      <b>{{info.status_text}}</b>
      <div class="r">
        <el-button type="danger" v-show="info.is_paid === 0" @click="goPay" round>立即支付</el-button>
      </div>
    </header>
    <figure class="desc">
      <h3>{{info.hotel_name}}</h3>
      <p>{{_.Address_CN}}</p>
      <router-link :to="{name: 'hotel_detail', query: {
        HotelID: info.hotel_id
      }}">查看详情>></router-link>
    </figure>
    <div class="order">
      <h4>订单信息</h4>
      <p><span>订单总价</span><b class="price">{{info.total_amount}}</b></p>
      <p><span>订单号</span><b>{{info.orders_sn}}</b></p>
      <p><span>下单时间</span><b>{{info.created_at}}</b></p>
    </div>
    <div class="room">
      <h4>{{info.room_name}}</h4>
      <p><span>酒店电话</span><b>{{_.Telephone}}</b></p>
      <p>{{info.CheckInDate | format('MM-DD')}}（周六）{{info.CheckOutDate | format('MM-DD')}}（周日） 共{{info.day}}晚</p>
    </div>
    <div class="hotel">
      <h4>预订信息</h4>
      <p><span>联系人</span><b>{{ info.contact_name }}</b></p>
      <p><span>入住人</span><b>{{getGuests}}</b></p>
      <p><span>联系手机</span><b>{{info.contact_phone}}</b></p>
      <p><span>电子邮箱</span><b>{{info.contact_email}}</b></p>
    </div>
    <div class="table">
      <h4>费用明细</h4>
      <el-table border :data="confirm.RatePlanList">
        <el-table-column label="日期" width="160">
          <template slot-scope="s">
            <span>{{ s.row.StayDate | format('YYYY-MM-DD') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="金额">
          <template slot-scope="s">
            <span class="price">{{ s.row.Price }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="serve">
      <h4>酒店服务</h4>
      <p><span v-for="(v,i) in hotel.facilities" :key="i">{{v.Description_CN}}</span></p>
    </div> -->
    <div class="table">
      <h4>退订服务</h4>
      <p class="hint" v-if="!confirm.canExit">不可退订</p>
      <el-table v-else border :data="confirm.CancellationPolicyList">
        <el-table-column prop="FromDate" label="日期" width="200">
        </el-table-column>
        <el-table-column label="取消及变更费用">
          <template slot-scope="s">
            <span class="price" :class="{green: s.row.Amount === 0}">{{ s.row.Amount > 0 ? s.row.Amount : '免费取消' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </section>
</main>
</template>

<script>
import moment from 'moment';
export default {
  data () {
    return {
      loading: true,
      info: {},
      hotel: {},
      confirm: {
        RatePlanList: []
      }
    }
  },
  created () {
    const { orders_sn } = this.$route.query;
    if ( !orders_sn ) {
      this.$router.push({ name: 'hotel' });
      return;
    }
    this.getInfo(orders_sn);
  },
  computed: {
    _ () {
      return this.hotel.hotelSummary || {};
    },
    getGuests () {
      const [{ first_name, last_name }] = this.info.hotel_order_guests;
      return last_name + first_name;
    }
  },
  filters: {
    format (val, desc = "MM月DD日") {
      return moment(val).format(desc);
    }
  },
  methods: {
    goPay () {
      const { orders_sn } = this.info;
      this.$router.push({ name: 'hotel_order_pay', query: { orderNo: orders_sn } });
    },
    async getInfo (orders_sn) {
      this.loading = true;
      const info = await this.$axios.get(`/hotelOrders/getOrderByUser?order_sn=${orders_sn}`);
      const hotel = await this.$axios.get('/didaApi/hotelInfo?HotelID='+info.hotel_id);

      let { Success: { PriceDetails: { HotelList: [ confirm ] } } } = JSON.parse(info.didaPriceConfirm);
      confirm.canExit = !!confirm.CancellationPolicyList.find(v => {
        const diff = moment(v.FromDate).diff(moment(), 'days');
        return diff > 0;
      });
      confirm.CancellationPolicyList = confirm.CancellationPolicyList.map(v => ({ ...v, date: moment(v.FromDate).format('MM-DD') }));
      confirm.CancellationPolicyList.unshift({
        FromDate: `${confirm.CancellationPolicyList[0].FromDate}前`,
        Amount: 0
      });
      confirm.RatePlanList = confirm.RatePlanList[0].PriceList.map(v => ({ ...v, date: moment(v.StayDate).format('MM-DD') }));
      this.info = info;
      this.hotel = hotel;
      this.confirm = confirm;
      this.loading = false;
    }
  }
}
</script>

<style scoped src="./order_detail.css"></style>